import { useMemo } from 'react';
import parse, { domToReact, Element, HTMLReactParserOptions } from 'html-react-parser';

import { ExtraDescriptionContainerProps } from '../containers/ExtraDescriptionContainer';
import {
  adjustAspectRatio,
  checkIsValidDomAttribute,
  checkLinkAttribute,
  checkNeedAdjustSource,
  checkScriptAttribute,
  parseAttributes,
  removeCssFontSize,
  removeCssImportantSyntax,
} from '../utils/html-parser';

export const useExtraDescriptionService = ({
  extra_description_list,
  display_description_key,
}: ExtraDescriptionContainerProps) => {
  const content = extra_description_list?.find((item) => item.key === display_description_key)?.value ?? '';
  const is_hide = !extra_description_list || !extra_description_list.length || !content;

  const parse_description = useMemo(() => {
    const wrap_description = `<div>${content}</div>`;

    const options: HTMLReactParserOptions = {
      replace: (_domNode) => {
        if (_domNode instanceof Element && _domNode.attribs) {
          let domNode = _domNode;

          if (checkScriptAttribute(domNode.name)) {
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return <></>;
          }

          if (!checkIsValidDomAttribute(domNode.name) || checkLinkAttribute(domNode.name)) {
            if (domNode.children.length > 0) {
              return <>{domToReact(domNode.children, options)}</>;
            }
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return <></>;
          }

          domNode.attribs = parseAttributes(domNode.attribs);
          if (!domNode.attribs.style) {
            domNode.attribs.style = '';
          }

          domNode = removeCssFontSize(domNode);

          domNode = removeCssImportantSyntax(domNode);

          // MEMO: youtube, vimeo인 경우에는 기존의 영상 비율을 유지하기 위해 스타일 추가
          // MEMO: border 제외 속성 누락된 경우 위해 추가
          if (domNode.name === 'iframe' && checkNeedAdjustSource(domNode.attribs.src)) {
            return adjustAspectRatio(domNode);
          }

          if (domNode.name === 'body') {
            return <div>{domToReact(domNode.children, options)}</div>;
          }

          if (domNode.name === 'table') {
            return <table className='extra-field-table'>{domToReact(domNode.children, options)}</table>;
          }

          return domNode;
        }
      },
    };
    return parse(wrap_description, options);
  }, [content]);

  return {
    is_hide,
    content: parse_description ?? '',
  };
};
